function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "icon-download_svg__a",
  d: "M23 15.01a1 1 0 011 1v6c0 1.103-.897 2-2 2H2c-1.103 0-2-.897-2-2v-6a1 1 0 112 0v6h20v-6a1 1 0 011-1zM11.994 18a.993.993 0 01-.356-.067l-.033-.014a.926.926 0 01-.088-.043l-.02-.011a.937.937 0 01-.087-.057l-.02-.016a.948.948 0 01-.097-.085l-4.999-4.989a.999.999 0 111.412-1.416L11 14.59V1a1 1 0 112 0v13.588l3.294-3.286a.999.999 0 111.412 1.416l-4.99 4.98a1.004 1.004 0 01-.105.094l.095-.084a1 1 0 01-.203.157l-.02.011a.925.925 0 01-.088.043l-.033.014a.891.891 0 01-.118.037A.994.994 0 0112 18h-.006z"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("use", {
  fillRule: "evenodd",
  xlinkHref: "#icon-download_svg__a"
});

var SvgIconDownload = function SvgIconDownload(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, props), _ref, _ref2);
};

export default SvgIconDownload;